import React, { Fragment } from 'react';
import { Slideshow, slideTypes, slideTextTypes } from 'abbot-core';
import audio1 from '../../assets/vo/U1-T2-1-1a.mp3';
import audio2 from '../../assets/vo/U1-T2-1-1b.mp3';
import audio3 from '../../assets/vo/U1-T2-1-1c.mp3';
import audio4 from '../../assets/vo/U1-T2-1-1d.mp3';
import audio5 from '../../assets/vo/U1-T2-1-1e.mp3';
import audio6 from '../../assets/vo/U1-T2-1-1f.mp3';
import audio7 from '../../assets/vo/U1-T2-1-1g.mp3';
import audio8 from '../../assets/vo/U1-T2-1-1h.mp3';
import img1 from '../../assets/images/U1-T2-1-1a.svg';
import img2 from '../../assets/images/U1-T2-1-1b.svg';
import img3 from '../../assets/images/U1-T2-1-1c.svg';
import img4 from '../../assets/images/U1-T2-1-1d.svg';
import img5 from '../../assets/images/U1-T2-1-1e_R.svg';
import img6 from '../../assets/images/U1-T2-1-1f_D.svg';
import img7 from '../../assets/images/U1-T2-1-1g_R.svg';
import img8 from '../../assets/images/U1-T2-1-1h_U.svg';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 7,
    image: img1,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Nutritious Food Choices'
    },
    vo: {
      sources: [
        {
          src: audio1
        }
      ],
      transcript: (
        <span>
          Most people know that eating the right types of food is important to
          staying healthy, but not many people really understand why it is so
          important.
        </span>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 3.3,
    image: img2,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Food is fuel.'
    },
    vo: {
      sources: [
        {
          src: audio2
        }
      ],
      transcript: <span>Your body uses food as fuel, like a car uses gas.</span>
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    duration: 5,
    image: img3,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: (
        <Fragment>
          <p>Strong Bones, Strong Muscles, and More Energy</p>
        </Fragment>
      )
    },
    vo: {
      sources: [
        {
          src: audio3
        }
      ],
      transcript: (
        <span>
          The food you eat can help you develop strong bones and muscles and can
          also increase your energy.
        </span>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 10.8,
    image: img4,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Noncommunicable Disease = Not Contagious'
    },
    vo: {
      sources: [
        {
          src: audio4
        }
      ],
      transcript: (
        <span>
          Making the most nutritious food choices possible also helps reduce the
          risk of developing certain noncommunicable diseases. Noncommunicable
          diseases are not infectious or contagious.
        </span>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 5.5,
    image: img5,
    imageAltText: '',
    // text: {
    //   type: slideTextTypes.BottomText,
    //   text: ''
    // },
    vo: {
      sources: [
        {
          src: audio5
        }
      ],
      transcript: (
        <span>
          These types of diseases can result from lifestyle choices, like what
          you eat, and can harm your health over time.
        </span>
      )
    }
  },
  {
    SlideType: slideTypes.VerticalPan,
    panDirection: 'down',
    duration: 4,
    image: img6,
    imageAltText: '',
    // text: {
    //   type: slideTextTypes.BottomText,
    //   text: 'Not exercising can harm your health.'
    // },
    vo: {
      sources: [
        {
          src: audio6
        }
      ],
      transcript: (
        <span>
          In this module, you will learn about how your body uses the food you
          put in it,
        </span>
      )
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    duration: 3.5,
    image: img7,
    imageAltText: '',
    // text: {
    //   type: slideTextTypes.BottomText,
    //   text: 'Not exercising can harm your health.'
    // },
    vo: {
      sources: [
        {
          src: audio7
        }
      ],
      transcript: (
        <span>
          the risks associated with making food choices that are not nutritious,
        </span>
      )
    }
  },
  {
    SlideType: slideTypes.VerticalPan,
    panDirection: 'up',
    duration: 3,
    image: img8,
    imageAltText: '',
    // text: {
    //   type: slideTextTypes.BottomText,
    //   text: 'Not exercising can harm your health.'
    // },
    vo: {
      sources: [
        {
          src: audio8
        }
      ],
      transcript: (
        <span>
          and how you can make the most nutritious food choices possible.
        </span>
      )
    }
  }
];

export default {
  title: 'Setup',
  path: '/prepare/setup',
  content: <Slideshow slides={slides} />
};



// WEBPACK FOOTER //
// ./src/data/prepare/Setup.js